module.exports = __webpack_public_path__ + "static/img/commonimg.5b7846ba.png";